import React from 'react';
import EditProfile from '3box-profile-edit-react';

const customFields = [
  {
    inputType: 'textarea',
    key: 'bio',
    field: 'Biography',
  },
  {
    inputType: 'textarea',
    key: 'song',
    field: 'Favorite Song',
  },
];
export default function Profile({ theBox, theSpace, myAddress }) {
  if (theBox === null) {
    return 'loading...';
  } else {
    console.log(theSpace);
    return (
      <div margin="5%">
        <EditProfile
          // required
          box={theBox}
          space={theSpace}
          currentUserAddr={myAddress}
          //optional
          customFields={customFields}
        />
      </div>
    );
  }
}
